import { useState } from 'react';
import { ReactComponent as LoadingSvg } from '../assets/svg/loading-half-status.svg';
import paypalLogo from '../assets/png/paypal-logo.png';
import buyMeACoffeeLogo from '../assets/png/buymeacoffee-logo.png';
import request from '../lib/request';

const Checkout = ({ openHowToBuymeacoffeeDialog }) => {
  const [isLoadingPayPal, setIsLoadingPayPal] = useState(false);

  // const handleClickPayPal = async () => {
  //   try {
  //     setIsLoadingPayPal(true);
  //     const { result } = await request.post('/paypal/subscription', {
  //       planId: selectedPlanId,
  //     });

  //     if (result && result.links) {
  //       const url = result.links.find((link) => link.rel === 'approve');
  //       if (url) {
  //         window.location.href = url.href;
  //       }
  //     }
  //   } catch (error) {
  //     console.error('Error approving transaction:', error);
  //   } finally {
  //     setIsLoadingPayPal(false);
  //   }
  // };

  const handleClickBuymeacoffee = async () => {
    try {
      openHowToBuymeacoffeeDialog();
    } catch (error) {
      console.error('Error approving transaction:', error);
    }
  };

  return (
    <div className='checkout mb-6'>
      {/* <button
        className='bg-secondary text-white w-full py-2 rounded-full flex justify-center items-center mb-2 border border-tertiary'
        onClick={handleClickPayPal}
        disabled={isLoadingPayPal}
      >
        {isLoadingPayPal ? (
          <LoadingSvg className='animate-spin' />
        ) : (
          <div className='flex items-center justify-center'>
            <img
              src={paypalLogo}
              alt='PayPal'
              className='w-4 h-4 mr-2'
            />
            Subscribe with<span className='font-bold ml-1 italic'>PayPal</span>
          </div>
        )}
      </button> */}
      <button
        className='bg-white border border-tertiary text-black w-full py-2 rounded-full flex justify-center items-center'
        onClick={handleClickBuymeacoffee}
      >
        <div className='flex items-center justify-center'>
          <img
            src={buyMeACoffeeLogo}
            alt='Buy me a coffee'
            className='h-5'
          />
          Get Access with
          <span className='font-bold ml-1'>Buymeacoffee</span>
        </div>
      </button>
    </div>
  );
};

const PayPalSubscriptionButton = ({
  selectedPlanId,
  closeDialog,
  refreshUser,
  openHowToBuymeacoffeeDialog,
}) => {
  return (
    <Checkout
      selectedPlanId={selectedPlanId}
      closeDialog={closeDialog}
      refreshUser={refreshUser}
      openHowToBuymeacoffeeDialog={openHowToBuymeacoffeeDialog}
    />
  );
};

export default PayPalSubscriptionButton;
